import { makeStyles } from '@material-ui/core';
import DocumentSignIcon from '../assets/images/document-sign-icon.svg?react';
import { DocumentData } from '../providers/FormProvider';
import Button from './Button';
import Modal from './Modal';
import PdfViewer from './PdfViewer';

const useStyles = makeStyles(() => ({
  documentWrapper: {
    margin: '24px 0 24px',
    display: 'inline-flex',
    gap: 12,
    flex: '0 0 auto',
  },
  icon: {
    color: '#fff',
    fill: '#fff',
  },
}));

export interface DocumentProps {
  id: string;
  modal: boolean;
  name: string;
  data: DocumentData | null;
  lowercase?: boolean;
  closeModal: () => void;
  handleClick: () => void;
}

function Document({
  closeModal,
  data,
  handleClick,
  modal,
  name,
  lowercase = false,
}: DocumentProps) {
  const classes = useStyles();

  return (
    <>
      <Button
        variant="tertiary"
        onClick={handleClick}
        data-testid="document-view-button"
      >
        View {lowercase ? name.toLowerCase() : name}
        <DocumentSignIcon className={classes.icon} />
      </Button>

      {data?.file && (
        <Modal
          maxWidth="lg"
          open={modal}
          title={data.title}
          closeHandler={closeModal}
          dataTestId="document-viewer-modal"
        >
          <PdfViewer modal file={data.file} name={data.id} />
        </Modal>
      )}
    </>
  );
}

export default Document;
